import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, inject } from '@angular/core';
import { FaroService } from '@core/services/faro.service';

@Injectable()
export class FaroErrorHandler implements ErrorHandler {
  private faroService = inject(FaroService);

  handleError(error: unknown): void {
    // HTTP errors are already captured and categorized by httpResponseInterceptor — skip to avoid duplicates
    if (error instanceof HttpErrorResponse) {
      return;
    }

    const err = error instanceof Error ? error : new Error(String(error));
    this.faroService.pushFrontendError(err);
  }
}
